var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12a7 7 0 1 1-2.05-4.95M19 4v4h-4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12a7 7 0 1 1-2.05-4.95M19 4v4h-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.77e00decdfa518046e5e667c5603c5b1.svg";
export { ForwardRef as ReactComponent };